import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogIn } from 'lucide-react';
import { AuthLayout } from '@vnetwork/ui/shells';
import { Button } from '@vnetwork/ui/primitives';
import { beginSso } from '@/lib/sso';

/** SSO-only sign-in — kicks off the Keycloak (realm `internal`) PKCE flow. */
export default function LoginPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const from = (location.state as { from?: string } | null)?.from ?? '/';

  return (
    <AuthLayout
      title={t('app.name')}
      subtitle={t('app.tagline')}
      eyebrow="VNETWORK"
    >
      <Button
        variant="primary"
        size="lg"
        startIcon={<LogIn size={18} />}
        loading={loading}
        onClick={() => {
          setLoading(true);
          void beginSso(from);
        }}
        style={{ width: '100%' }}
      >
        {t('auth.signInWithSso')}
      </Button>
    </AuthLayout>
  );
}
